import { generatePath, useParams } from 'react-router-dom'

import PaymentRedirectView from 'components/ui/PaymentRedirect'
import { appRoutes } from 'routes'

const PaymentRedirect = () => {
  const { uuid } = useParams<{ uuid: string }>()
  return (
    <PaymentRedirectView transactionPageUrl={generatePath(appRoutes.buyProceed.path, { uuid })} />
  )
}

export default PaymentRedirect
